import React from 'react';
import { Button } from '../../../components/ui/button';

interface ContactsFiltersModalProps {
    open: boolean;
    onClose: () => void;
    etapa: string;
    setEtapa: (v: string) => void;
    agente: string;
    setAgente: (v: string) => void;
    usuario: string;
    setUsuario: (v: string) => void;
    estado: string;
    setEstado: (v: string) => void;
    etapaOptions: string[];
    agenteOptions: string[];
    usuarioOptions: string[];
    estadoOptions: string[];
    onClear: () => void;
    onApply: () => void;
}

const ContactsFiltersModal: React.FC<ContactsFiltersModalProps> = ({
    open,
    onClose,
    etapa,
    setEtapa,
    agente,
    setAgente,
    usuario,
    setUsuario,
    estado,
    setEstado,
    etapaOptions,
    agenteOptions,
    usuarioOptions,
    estadoOptions,
    onClear,
    onApply,
}) => {
    if (!open) return null;
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="absolute inset-0 bg-black bg-opacity-30" onClick={onClose} />
            <div className="relative bg-white rounded-2xl shadow-lg w-[60vh] max-w-full flex flex-col">
                {/* Modal Header */}
                <div className="flex items-center bg-gray-100 rounded-tl-2xl rounded-tr-2xl justify-between px-6 py-4 border-b">
                    <span className="font-semibold text-lg text-maxi-text-dark">Filtros</span>
                    <Button
                        variant="default"
                        className="text-lg bg-primary rounded-full px-3 shadow"
                        onClick={onClose}
                    >
                        ×
                    </Button>
                </div>
                {/* Modal Content */}
                <div className="px-6 py-6 grid grid-cols-2 gap-6">
                    <div>
                        <label htmlFor="etapa" className="block text-sm font-medium text-maxi-text-dark mb-2">Etapa</label>
                        <select
                            id="etapa"
                            value={etapa}
                            onChange={e => setEtapa(e.target.value)}
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-maxi-green"
                        >
                            <option value="">Selecciona etapa</option>
                            {etapaOptions.map(opt => (
                                <option key={opt} value={opt}>{opt}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label htmlFor="agente" className="block text-sm font-medium text-maxi-text-dark mb-2">Agente</label>
                        <select
                            id="agente"
                            value={agente}
                            onChange={e => setAgente(e.target.value)}
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-maxi-green"
                        >
                            <option value="">Selecciona agente</option>
                            {agenteOptions.map(opt => (
                                <option key={opt} value={opt}>{opt}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label htmlFor="usuario" className="block text-sm font-medium text-maxi-text-dark mb-2">Usuario</label>
                        <select
                            id="usuario"
                            value={usuario}
                            onChange={e => setUsuario(e.target.value)}
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-maxi-green"
                        >
                            <option value="">Selecciona usuario</option>
                            {usuarioOptions.map(opt => (
                                <option key={opt} value={opt}>{opt}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label htmlFor="estado" className="block text-sm font-medium text-maxi-text-dark mb-2">Estado</label>
                        <select
                            id="estado"
                            value={estado}
                            onChange={e => setEstado(e.target.value)}
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-maxi-green"
                        >
                            <option value="">Selecciona estado</option>
                            {estadoOptions.map(opt => (
                                <option key={opt} value={opt}>{opt}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-span-2 flex gap-3 justify-end mt-4">
                        <Button
                            variant="secondary"
                            className="px-4 py-2 rounded-full px-6 font-medium hover:bg-gray-300"
                            onClick={onClear}
                        >
                            Limpiar Filtros
                        </Button>
                        <Button
                            variant="default"
                            className="px-4 py-2 rounded-full px-6 font-medium hover:bg-gray-300"
                            onClick={onApply}
                        >
                            Aplicar
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactsFiltersModal;
